/*
 * @Author: 刘小博
 * @Date: 2023-02-17 15:43:18
 * @LastEditTime: 2023-02-17 15:50:49
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-settle-accounts\modules\shipmentsSettleAccountsRouter.js
 * 发货结算
 */
const shipmentsSettleAccountsRouter = [
  // 费控系统 发货结算 发货单管理
  {
    path: '/costControlSystem/delivery-settlement/invoice',
    name: 'costControlSystemDeliverySettlementInvoice',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/index.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '发货单管理',
    },
  },

  // 费控系统 发货结算 发货单管理 发货单新增编辑
  {
    path: '/costControlSystem/delivery-settlement/invoice/add-edit/:cost_invoice_id',
    name: 'costControlSystemDeliverySettlementInvoiceAddEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/addEdit.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '新增发货单',
      breadcrumb: [
        {
          title: '发货单管理',
          name: 'costControlSystemDeliverySettlementInvoice',
        },
      ],
    },
  },
  // 费控系统 发货结算 发货单管理 发货单详情
  {
    path: '/costControlSystem/delivery-settlement/invoice/detail/:cost_invoice_id',
    name: 'costControlSystemDeliverySettlementInvoiceDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/detail.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '发货单详情',
      breadcrumb: [
        {
          title: '发货单管理',
          name: 'costControlSystemDeliverySettlementInvoice',
        },
      ],
    },
  },
  // 费控系统 发货结算 发货单管理 发货单导入
  {
    path: '/costControlSystem/delivery-settlement/invoice/import',
    name: 'costControlSystemDeliverySettlementInvoiceImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/Import.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '发货单导入',
      breadcrumb: [
        {
          title: '发货单管理',
          name: 'costControlSystemDeliverySettlementInvoice',
        },
      ],
    },
  },
  // 费控系统 发货结算 发货单审核
  {
    path: '/costControlSystem/delivery-settlement/invoice/to-examine',
    name: 'costControlSystemDeliverySettlementInvoiceToExamine',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/toExamine.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '发货单审核',
    },
  },
  // 费控系统 发货结算 发货单管理 发货单详情（审核跳转的）
  {
    path: '/costControlSystem/delivery-settlement/invoice/to-examine-detail/:cost_invoice_id',
    name: 'costControlSystemDeliverySettlementInvoiceToExamineDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/invoice/detail.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '发货单详情',
      breadcrumb: [
        {
          title: '发货单审核',
          name: 'costControlSystemDeliverySettlementInvoiceToExamine',
        },
      ],
    },
  },
  // 费控系统 发货结算 服务商结算清单
  {
    path: '/costControlSystem/delivery-settlement/settlement',
    name: 'costControlSystemDeliverySettlementSettlement',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/settlement/index.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '服务商结算清单',
    },
  },
  // 费控系统 发货结算 服务商结算审核
  {
    path: '/costControlSystem/delivery-settlement/settlement/to-examine',
    name: 'costControlSystemDeliverySettlementSettlementToExamine',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/settlement/toExamine.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '服务商结算审核',
    },
  },
  // 费控系统 发货结算 服务商结算审核 详情
  {
    path: '/costControlSystem/delivery-settlement/settlement/detail/:cost_invoice_id/:disabledToExamine',
    name: 'costControlSystemDeliverySettlementSettlementDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/settlement/detail.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '服务商结算详情',
      breadcrumb: [
        {
          title: '服务商结算清单',
          name: 'costControlSystemDeliverySettlementSettlement',
        },
      ],
    },
  },
  // 费控系统 发货结算 服务商结算审核 详情(审核详情)
  {
    path: '/costControlSystem/delivery-settlement/settlement/to-examine/detail/:cost_invoice_id',
    name: 'costControlSystemDeliverySettlementSettlementToExamineDetail',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/deliverySettlement/settlement/detail.vue'
      ),
    meta: {
      SecondaryMenu: '发货结算', //二级菜单
      title: '服务商结算详情',
      breadcrumb: [
        {
          title: '服务商结算审核',
          name: 'costControlSystemDeliverySettlementSettlementToExamine',
        },
      ],
    },
  },

]

export default shipmentsSettleAccountsRouter
